var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowformLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 28,
    viewBox: "0 0 120 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.82,6.79a4.28,4.28,0,0,0-3.54,1.67V7.1H28.46V22.15h2.82V16.61a4.28,4.28,0,0,0,3.54,1.67,4.56,4.56,0,0,0,3.76-1.67,5.87,5.87,0,0,0,1.56-4.07,5.55,5.55,0,0,0-1.56-4.08,4.9,4.9,0,0,0-3.76-1.67Zm81.11,0a4.31,4.31,0,0,0-3.75,2,3.66,3.66,0,0,0-3.54-2,3.91,3.91,0,0,0-3.24,1.57V7.1h-2.81v11h2.81V11.81a2.19,2.19,0,0,1,2.3-2.3,2.14,2.14,0,0,1,2.19,2.19V18h2.81V11.7A2.19,2.19,0,0,1,115,9.4a2,2,0,0,1,2.19,2.2v6.27H120V10.76a3.93,3.93,0,0,0-1.15-2.92,4.28,4.28,0,0,0-2.92-1ZM97.58,7.1H94.77v11h2.81V12.85c0-1.88,1.15-3,3.24-3V6.9a4,4,0,0,0-3.24,1.77V7.1Zm-6.25,9.62A5.52,5.52,0,0,0,93,12.64a5.19,5.19,0,0,0-1.67-4.07A6,6,0,0,0,87.16,6.9,5.41,5.41,0,0,0,83,8.57a5.19,5.19,0,0,0-1.67,4.07A5.23,5.23,0,0,0,83,16.72a5.57,5.57,0,0,0,4.17,1.67A6.56,6.56,0,0,0,91.33,16.72Zm-6.36-2a2.89,2.89,0,0,1-.83-2.19,3.39,3.39,0,0,1,.83-2.2,2.78,2.78,0,0,1,2.19-.83,3.39,3.39,0,0,1,2.19.83,2.8,2.8,0,0,1,.83,2.2,3.39,3.39,0,0,1-.83,2.19,2.75,2.75,0,0,1-2.19.84A2.57,2.57,0,0,1,85,14.73ZM80.59,2.61H74.86v4.5H73.19V9.72h1.67v8.46h2.81V9.61h3V7.11h-3v-2h3V2.61ZM66.73,14.52,64.33,7.1H61.51l-2.4,7.42L56.82,7.1H53.59l4,11h2.92l2.4-7.62,2.4,7.62h2.91l4-11H69Zm-15.12,2.2a5.56,5.56,0,0,0,1.67-4.08,5.23,5.23,0,0,0-1.67-4.07A6,6,0,0,0,47.44,6.9a5.56,5.56,0,0,0-4.17,1.67,5.35,5.35,0,0,0-1.67,4.07,5.23,5.23,0,0,0,1.67,4.08,5.56,5.56,0,0,0,4.17,1.67A6.56,6.56,0,0,0,51.61,16.72Zm-6.36-2a2.9,2.9,0,0,1-.84-2.19,3.4,3.4,0,0,1,.84-2.2,2.77,2.77,0,0,1,2.19-.83,3.39,3.39,0,0,1,2.19.83,2.8,2.8,0,0,1,.83,2.2,3.39,3.39,0,0,1-.83,2.19,3,3,0,0,1-2.19.94A3,3,0,0,1,45.25,14.73Zm-13.14,0a3,3,0,0,1-.83-2.19,3.39,3.39,0,0,1,.83-2.2,2.78,2.78,0,0,1,2.19-.83,3.35,3.35,0,0,1,2.19.83,2.77,2.77,0,0,1,.84,2.2,3.4,3.4,0,0,1-.84,2.19,2.74,2.74,0,0,1-2.19.84A2.46,2.46,0,0,1,32.11,14.73Z",
    fill: "#485778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.16,5,11.89,7,7.51,4.18,16.16.1Z",
    fill: "#a7cd3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.54,11.91,16.26,14l-4.37-2.82L20.54,7.1Z",
    fill: "#0089d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,21.52,16.26,14v4.07L3.75,23.93V28L0,25.6Z",
    fill: "#01b7cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.54,11.89,7v4.18L3.75,14.94Z",
    fill: "#f8931d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.55,7.51,0V4.18L3.75,6Z",
    fill: "#e1e41b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowformLogo);
export default __webpack_public_path__ + "static/media/powform-logo.1631218788f4f57f28fc18ecd0dfe4f9.svg";
export { ForwardRef as ReactComponent };